import React, {Component} from 'react';
import PropTypes from 'prop-types';

class RubricaListTypeButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let classNameLista = "ui " + (this.props.listType === 'l' ? "positive" : "") + " button"
        let classNameSingolo = "ui " + (this.props.listType === 's' ? "positive" : "") + " button"
        // let classNameReport = "ui " + (this.props.listType === 'r' ? "positive" : "") + " button"

        return (
        <div className="ui buttons">
            <button className={classNameLista} onClick={() => this.props.onButtonClick('l')}>Lista</button>
            <div className="or" data-text="o"></div>
            <button className={classNameSingolo} onClick={() => this.props.onButtonClick('s')}>Singolo</button>
            {/*<div className="or" data-text="o"></div>*/}
            {/*<button className={classNameReport} onClick={() => this.props.onButtonClick('r')}>Report</button>*/}
        </div>
        )
    }
}
RubricaListTypeButton.PropTypes = {
    listType: PropTypes.oneOf(['l', 's']).isRequired, // l: List s:Single
    iconSize: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired // argomento:  listType: t/s
}

RubricaListTypeButton.defaultProps = {
    iconSize: ""
};

export default RubricaListTypeButton;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaListTypeButton.jsx
 **/